import React from 'react'
import { AudienceTags } from '../../../../shared/components/AudienceTags'
import { DataTableCount, DataTableStatus, DataTableText } from '../../../../shared/components/DataTable'
import { getDateLabel, toDisplayValue, toListLabel, toYesNo } from '../../../../shared/utils/displayValue'
import { VALUE_MESSAGE_STATUSES } from '../ValueMessageTable.constants'
import { ValueMessageColumnId, ValueMessageRow } from '../ValueMessageTable.types'

const text = (value?: string | null, maxLines?: number) => (
    <DataTableText text={toDisplayValue(value)} maxLines={maxLines} />
)

export const renderValueMessageCell = (valueMessage: ValueMessageRow, columnId: ValueMessageColumnId) => {
    switch (columnId) {
        case 'name':
            return (
                <DataTableText
                    text={toDisplayValue(valueMessage.name)}
                    variant="16x600"
                    color="figma.grayscale.textHier1"
                    maxLines={3}
                />
            )
        case 'status': {
            const status = VALUE_MESSAGE_STATUSES.find((option) => option.id === valueMessage.status)
            return status ? <DataTableStatus icon={status.icon} label={status.id} /> : text(valueMessage.status)
        }
        case 'category':
            return text(valueMessage.categoryName)
        case 'narrative':
            return text(valueMessage.narrativeName, 2)
        case 'priority':
            return text(valueMessage.priority)
        case 'description':
            return text(valueMessage.description, 3)
        case 'audiences':
            return <AudienceTags audiences={valueMessage.audienceNames} maxVisible={3} />
        case 'internalStakeholders':
            return text(toListLabel(valueMessage.internalStakeholderNames), 3)
        case 'localMarkets':
            return text(toListLabel(valueMessage.localMarkets), 3)
        case 'isCountrySpecific':
            return text(toYesNo(valueMessage.isCountrySpecific))
        case 'isInternal':
            return text(toYesNo(valueMessage.isInternal))
        case 'linkedEvidenceCount':
            return <DataTableCount value={valueMessage.linkedEvidenceCount} />
        case 'primaryEvidenceCount':
            return <DataTableCount value={valueMessage.primaryEvidenceCount} />
        case 'keyEvidenceStatementCount':
            return <DataTableCount value={valueMessage.keyEvidenceStatementCount} />
        case 'evidenceGapCount':
            return <DataTableCount value={valueMessage.evidenceGapCount} />
        case 'linkedActivityCount':
            return <DataTableCount value={valueMessage.linkedActivityCount} />
        case 'linkedStrategicImperativeCount':
            return <DataTableCount value={valueMessage.linkedStrategicImperativeCount} />
        case 'linkedTppCellCount':
            return <DataTableCount value={valueMessage.linkedTppCellCount} />
        case 'createdAt':
            return text(getDateLabel(valueMessage.createdAtValue))
        case 'updatedAt':
            return text(getDateLabel(valueMessage.updatedAtValue))
        default:
            return null
    }
}
